var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_35355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 36C28.441 36 36.4999 27.9411 36.4999 18C36.4999 8.05887 28.441 0 18.4999 0C8.55884 0 0.5 8.05887 0.5 18C0.5 27.9411 8.55884 36 18.4999 36Z",
    fill: "#2CA01C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.9992C5.5 21.8792 8.61995 24.9992 12.4999 24.9992H13.5V22.3992H12.4999C10.06 22.3992 8.09998 20.4391 8.09998 17.9992C8.09998 15.5592 10.06 13.5992 12.4999 13.5992H14.8999C14.8999 13.5992 14.8999 26.9592 14.8999 27.1992C14.8999 28.6392 16.06 29.7992 17.4999 29.7992V10.9993C17.4999 10.9993 14.82 10.9993 12.4999 10.9993C8.61995 10.9993 5.5 14.1592 5.5 17.9992ZM24.5 10.9993H23.4999V13.5993H24.5C26.94 13.5993 28.8999 15.5592 28.8999 17.9992C28.8999 20.4392 26.94 22.3992 24.5 22.3992H22.1C22.1 22.3992 22.1 9.03929 22.1 8.79921C22.1 7.35928 20.9399 6.19922 19.5 6.19922V24.9992C19.5 24.9992 22.1799 24.9992 24.5 24.9992C28.38 24.9992 31.5 21.8792 31.5 17.9992C31.5 14.1592 28.38 10.9993 24.5 10.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_35355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.6771e8a9b75ee7f8d09d4abeac152521.svg";
export { ForwardRef as ReactComponent };